const QuotaBadge = ({ percent }) => {
  const value = Number(percent) || 0;

  let bgColor = "bg-red-100 text-red-700";
  let label = "Below Target";

  if (value >= 100) {
    bgColor = "bg-green-100 text-green-700";
    label = "Target Met";
  } else if (value >= 90) {
    bgColor = "bg-yellow-100 text-yellow-700";
    label = "Near Target";
  }

  return (
    <div
      className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-semibold ${bgColor}`}
    >
      {value.toFixed(1)}%
    </div>
  );
};

export default QuotaBadge;
